import { useTranslation } from 'react-i18next';

import style from './TBCPayButton.module.css';
import { EVENT_NAMES, useSendEventLog } from '../../../event-log';
import { useStartTbcSession } from '../../hooks/useStartTbcSession';
import { RedirectPaymentResult } from '../../payment.types';

interface TBCPayButtonProps {
    orderId: string;
    loyaltyId: number;
    onPaymentSuccess: (result: RedirectPaymentResult) => void;
    onPaymentFailed: () => void;
    onError: (error: unknown) => void;
}

const TBCPayButton = ({
    orderId,
    loyaltyId,
    onPaymentSuccess,
    onPaymentFailed,
    onError,
}: TBCPayButtonProps) => {
    const { t } = useTranslation();
    const tbcSession = useStartTbcSession();
    const { sendEvent } = useSendEventLog();

    function onRequestTbcPayment() {
        sendEvent({ name: EVENT_NAMES.paymentInitiated.TBC });
        tbcSession.mutate(
            { orderId, loyaltyId },
            {
                onSuccess: (data) => onPaymentSuccess(data),
                onError: () => onPaymentFailed(),
            },
        );
    }

    return (
        <button
            className={`${style.pay_button}  tbc-checkout-pay ${style.tbcCheckoutPay}`}
            id="tbcCheckoutButton"
            onClick={onRequestTbcPayment}
        >
            <div className={style.tbcCheckoutButtonLogo}>
                <img
                    alt="TBC Bank"
                    height="24"
                    src="/images/tbc-logo-white.svg"
                />
                <span>{t('Pay')}</span>
            </div>
            <div className={style.tbcCheckoutCardIcons}>
                <img alt="Visa" src="/images/visa.svg" />
                <img alt="Mastercard" src="/images/mc.svg" />
                <img alt="QR" src="/images/QR.svg" />
            </div>
        </button>
    );
};

export { TBCPayButton };
